import { useDataViewChartView } from '@aibees/elephant/context/data-view-context';
import { memo } from 'react';
import { DataViewSwitcher } from '../data-view-switcher';
import type { TableDataViewSwitcherProps as Props } from './types';

export const TableDataViewSwitcher = memo(({ className }: Props) => {
  const { isChartView } = useDataViewChartView();

  if (!isChartView) {
    return <DataViewSwitcher />;
  }
  return null;
});

TableDataViewSwitcher.displayName = 'TableDataViewSwitcher';
